import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Tab, Table, Tabs } from "react-bootstrap";
import toast from "react-hot-toast";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Delete from "../../Components/Modals/DeleteModal";
import Navbar from "../../Components/Navbar/Navbar";
import TableTemplate from "../../Components/TableTemplate/Table";
import {
    getType,
    isAdmin,
    numberFormat,
    refreshPage,
    selectDropdownStyle,
    toastStyle,
    TokenExpiry,
} from "../../Helpers/Utils/Common";
import "./Manage.css";
import {
    getAllBuildItem,
    getBuildItem,
} from "../../Helpers/apiCalls/Manage/BuildItem";
import { getAllBranches } from "../../Helpers/apiCalls/branchApi";
import InputError from "../../Components/InputError/InputError";
import AddModal from "../../Components/Modals/AddModal";
import trash from "../../Assets/Images/trash.png";
import { getAllItems } from "../../Helpers/apiCalls/itemsApi";
import Select from "react-select";
import { getAllEmployees } from "../../Helpers/apiCalls/employeesApi";
import EditModal from "../../Components/Modals/EditModal";
import ViewModal from "../../Components/Modals/ViewModal";
import Moment from "moment";
import upload from "../../Assets/Images/upload.png";
import { Upload} from "antd";
import { createJobOrder, deleteJobOrder, getJobOrder, updateJobOrder } from "../../Helpers/apiCalls/Manage/JobOrder";
import Footer from "../../Components/Footer/Footer";
import TableWithDynamicPagination from "../../Components/TableTemplate/TableWithDynamicPagination";

export default function BuildItem() {
    const { Dragger } = Upload;
    let navigate = useNavigate();
    const accountType = getType();
    const [isClicked, setIsClicked] = useState(false);
    /* delete modal handler */
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => refreshPage();
    const [inactive, setInactive] = useState(true);
    const [showLoader, setShowLoader] = useState(false);
    const [selectedRow, setSelectedRow] = useState({});
    const [build, setBuild] = useState({});
    const [branchInfo, setBranchInfo] = useState([]);
    const [itemInfo, setItemInfo] = useState([]);
    const [materials, setMaterials] = useState([]);
    const [materialsRequired, setMaterialsRequired] = useState([
        { id: "", quantity: "1", unit: "", unitList: [] },
    ]);
    const [materialsUsed, setMaterialsUsed] = useState([]);
    const [labor, setLabor] = useState([
        { employee_id: "", job_description: "", rate: "" },
    ]);
    const [qty, setQty] = useState("");
    const [branchFrom, setBranchFrom] = useState("2"); // building to commissary by default
    const [file, setFile] = useState("");
    const [fileList, setFileList] = useState([]);
    const date = new Date();
    date.setDate(date.getDate() - 7);
    const nextDay = new Date();
    nextDay.setDate(nextDay.getDate() + 1);

    /* FILTER CONFIGS */
    const today = Moment().format("MM/DD/YYYY");
    const [buildItemManager, setBuildItemManager] = useState([]);
    const [filterConfig, setFilterConfig] = useState({
        name: "",
        item_id: "",
        status: "pending",
        tab: "pending",
        added_on_from: date,
        added_on_to: nextDay,
        totalBuiltItem: "",
        hasChanged: false,
        page: 1
    });
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Change this based on your requirement

    const handlePageChange = page => {
        setCurrentPage(page);
        setFilterConfig(prev => ({
        ...prev,
        page: page,
        }));
    };

    //Error Handling
    const [isError, setIsError] = useState({
        branch_from: false,
        qty: false,
        ingredients: false,
    });

    //MODAL HANDLERS
    const [showAddBranchModal, setShowAddBranchModal] = useState(false);
    const handleShowAddBranchModal = () => {
        clearTables();
        setShowAddBranchModal(true);
        setBranchInfo(branches.filter((info) => info.id === "2"));
        setMaterialsRequired([{ id: "", quantity: "1", unit: "", unitList: [] }]);
    };
    const handleCloseAddBranchModal = () => {
        setShowAddBranchModal(false);
    };

    // ADD
    const [showAddItemModal, setShowAddItemModal] = useState(false);
    const handleShowAddItemModal = () => {
        clearTables();
        setShowAddItemModal(true);
    };
    const handleCloseAddItemModal = () => {
        clearTables();
        setShowAddItemModal(false);
    };

    //EDIT
    const [showEditItemModal, setShowEditItemModal] = useState(false);
    const handleShowEditItemModal = () => {
        setShowEditItemModal(true);
    };
    const handleCloseEditItemModal = () => setShowEditItemModal(false);

    //VIEW
    const [showViewItemModal, setShowViewItemModal] = useState(false);
    const handleShowViewItemModal = () => {
        setShowViewItemModal(true);
    };
    const handleCloseViewItemModal = () => setShowViewItemModal(false);

    function clearTables() {
        setQty("");
        // setBranchFrom("");
        setBuild([]);
        // setBranchInfo([]);
        setItemInfo([]);
        setFileList([]);
        setMaterialsRequired([]);
        setMaterialsUsed([]);
        setLabor([]);
    }

    const handleRemove = (selectedFile) => {
        var newlist = file.filter((file) => {
            return selectedFile.uid !== file.uid;
        });
        setFile(newlist);
    };

    const handleBeforeUpload = (file) => {
        setFileList([...fileList, file]);
        return false;
    };

    async function handleSaveBuildItem() {
        // if (validateBuildItem(qty, branchFrom, materialsRequired, setIsError)) {
            setIsClicked(true);
            build.attachments = fileList
            build.status = "pending"
            const response = await createJobOrder(build, materialsRequired);
            if (response.data) {
                toast.success(response.data.message, {style: toastStyle()});
                handleCloseAddItemModal();
                setFilterConfig((prev) => {
                    return { ...prev, hasChanged: !filterConfig.hasChanged };
                });
            } else {
                setIsClicked(false);
                response.error?.response?.data?.messages.map((data) => {
                    return toast.error(data);
                })
            }
            setIsClicked(false);
        // }
    }

    async function handleUpdateBuildItem() {
        // if (validateBuildItem(qty, branchFrom, materialsRequired, setIsError)) {
            setIsClicked(true);
            build.attachments = fileList
            const response = await updateJobOrder(build, materialsRequired);
            if (response) {
                toast.success(response.data.message, {style: toastStyle()});
                handleCloseEditItemModal();
                setFilterConfig((prev) => {
                    return { ...prev, hasChanged: !filterConfig.hasChanged };
                });
            } else {
                response.error?.response?.data?.messages.map((data) => {
                    return toast.error(data);
                })
            }
            setIsClicked(false);
        // }
    }

    async function handleDeleteBuildItem() {
        setIsClicked(true);
        const response = await deleteJobOrder(selectedRow.id);
        if (response) {
            toast.success("Deleted Successfully!", {
                style: toastStyle(),
            });
            setTimeout(() => refreshPage(), 1000);
        } else {
            toast.error("Error Deleting", {
                style: toastStyle(),
            });
        }
    }

    //FETCH
    const [branches, setBranches] = useState([]);
    const [items, setItems] = useState([]);
    const [employees, setEmployees] = useState([]);

    async function fetchBranches() {
        setBranches([]);
        const response = await getAllBranches();
        var allBranches = response.data.data

        setBranches(allBranches);
    }

    async function fetchEmployees() {
        setEmployees([]);
        const response = await getAllEmployees();
        if(response.data) {
            var data = response.data.data.map((data) => {
                var info = data
                info.name = data.first_name + " " + data.last_name
                return info
            })
            setEmployees(data);
        }
    }

    async function fetchBuildItem() {
        const response = await getBuildItem(selectedRow.id);

        if (response.data) {
            let itemResult = response.data?.data[0]?.build_item_details.map(
                (a, index) => {
                    let itemList = items.filter(
                        (info) => info.id === a.item_id
                    );
                    return {
                        id: a.item_id,
                        item_name: a.item_name,
                        quantity: a.qty,
                        unit: a.unit_from,
                        unit_to: a.unit_to,
                        unitList: { item_units: itemList[0]?.item_units },
                    };
                }
            );

            let branchInfo = branches.filter(
                (info) => info.id === response.data?.data[0]?.to_branch_id
            );
            let itemInfo = items.filter(
                (info) => info.id === response.data?.data[0]?.item_id
            );
            let prod_date =
                response.data?.data[0]?.production_date !== null
                    ? response.data?.data[0]?.production_date.split(" ")[0]
                    : response.data?.data[0]?.production_date;
            let exp_date =
                response.data?.data[0]?.expiration_date !== null
                    ? response.data?.data[0]?.expiration_date.split(" ")[0]
                    : response.data?.data[0]?.expiration_date;
            let processing_date =
                response.data?.data[0]?.processing_date !== null
                    ? response.data?.data[0]?.processing_date.split(" ")[0]
                    : response.data?.data[0]?.processing_date;
            setBuild({
                total_qty: response.data?.data[0]?.total_qty,
                production_date: prod_date,
                expiration_date: exp_date,
                brix: response.data?.data[0].brix,
                remarks: response.data?.data[0].remarks,
                processing_date: processing_date,
                batch: response.data?.data[0]?.batch,
                production_slip_no: response.data?.data[0]?.production_slip_no,
            });
            setBranchInfo(branchInfo);
            setItemInfo(itemInfo);
            setMaterialsRequired(itemResult);
            setQty(response.data?.data[0].qty);
            setBranchFrom(response.data?.data[0].from_branch_id);
        } else if (response.error) {
            setBuild({});
            setBranchInfo([]);
            setItemInfo([]);
            setMaterialsRequired([]);
            setQty("");
            setBranchFrom("");
            TokenExpiry(response);
        }
    }

    const [totalBuiltItem, setTotalBuiltItem] = useState("");
    async function fetchData() {
        setTotalBuiltItem(0);
        setBuildItemManager([]);
        setShowLoader(true);
        setTotalItems(0)
        const response = await getJobOrder(filterConfig);
        if (response.data) {
            let items = response.data.data.map((item) => {
                var info = item
                info.order_date = item.job_order_date ? Moment(item.job_order_date).format("MMM DD, YYYY") : ""
                info.sched_date = item.schedule_date ? Moment(item.schedule_date).format("MMM DD, YYYY") : ""
                return info
            });
            var _totalBuiltItem = items.length;

            setTotalBuiltItem(_totalBuiltItem);
            setBuildItemManager(items);
            setTotalItems(response.data.size);
        }
        setShowLoader(false);
    }

    const handleBuildInfoChange = (e) => {
        if (typeof e === "string") {
            setBuild((prevState) => ({
                ...prevState,
                ["item"]: e,
            }));
            setItemInfo(items.filter((info) => info.id === e));
        } else if (e.target.name === "branch") {
            const { name, value } = e.target;
            setBuild((prevState) => ({
                ...prevState,
                [name]: value,
            }));
            setBranchInfo(branches.filter((info) => info.id === value));
            fetchItems(value);
        } else if (e.target.name === "build_item_id"){
            const { name, value } = e.target;
            const unit = getUnits(value);
            
            setBuild((prevState) => ({
                ...prevState,
                [name]: value,
                "unitList": unit[0],
                "build_item_unit": unit[0].item_units[0].unit_to,
                "build_item_unit_id": unit[0].item_units[0].id
            }));

        } else {
            const { name, value } = e.target;
            
            setBuild((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        }
    };
    

    function handleSelectChange(e, row) {
        setBuild([]);
        setSelectedRow(row);
        if (e.target.value === "edit-ps") {
            setBuild(row)
            // var data = row.items.map((item) => {
            //     let itemList = items.filter(
            //         (info) => info.id === item.item_id
            //     );
            //     var info = item
            //     info.unitList = { item_units: itemList[0]?.item_units }
            //     info.build_item_id = item.id //to save build item id
            //     info.id = item.item_id //to set id to item id for the table to show the item
            //     return info
            //     }
            // );
            // setMaterialsRequired(data)
            handleShowEditItemModal();
            navigate("/builditem/edit/" + row.id);
        } else if (e.target.value === "delete-ps") {
            handleShowDeleteModal();
        } else if (e.target.value === "view-ps") {
            navigate("/builditem/view/" + row.id);
        }
    }

    function getUnits(id) {
        return items.filter((item) => item.id === id);
    }

    // MATERIAL REQUIRED TABLE FUNCTIONS
    function handleMaterialRequiredChange(e, index) {
        const { name, value } = e.target;
        const list = [...materialsRequired];
        list[index][name] = value;

        if (name === "id") {
            const unit = getUnits(value);
            list[index]["unitList"] = unit[0];
            list[index]["item_unit_id"] = unit[0].item_units[0].id;
            list[index]["unit"] = unit[0].item_units[0].unit_to;
        }
        setMaterialsRequired(list);
    }

    function AddMaterialRequiredBtn() {
        const newProduct = { name: "", quantity: "1", unit: "" };
        setMaterialsRequired((prevProduct) => [...prevProduct, newProduct]);
    }

    function handleRemoveMaterialRequired(id) {
        const rowId = id;
        const newProductList = [...materialsRequired];
        newProductList.splice(rowId, 1);
        setMaterialsRequired(newProductList);
    }

    // MATERIAL USED TABLE FUNCTIONS
    function handleMaterialUsedChange(e, index) {
        const { name, value } = e.target;
        const list = [...materialsUsed];
        list[index][name] = value;

        if (name === "id") {
            const unit = getUnits(value);
            list[index]["unitList"] = unit[0];
            list[index]["unit"] = unit[0].item_units[0].id;
        }
        setMaterialsUsed(list);
    }

    function AddMaterialUsedBtn() {
        const newProduct = { name: "", quantity: "1", unit: "" };
        setMaterialsUsed((prevProduct) => [...prevProduct, newProduct]);
    }

    function handleRemoveMaterialUsed(id) {
        const rowId = id;
        const newProductList = [...materialsUsed];
        newProductList.splice(rowId, 1);
        setMaterialsUsed(newProductList);
    }

    function ActionBtn(row) {
        return (
            <Form.Select
                name="action"
                role={row.payment_mode}
                id={row.id}
                className="PO-select-action"
                onChange={(e) => handleSelectChange(e, row)}
            >
                <option value="" selected hidden>
                    Select
                </option>
                <option value="view-ps" className="color-options">
                    View
                </option>
                {isAdmin() && filterConfig.tab !== "rejected" && (
                    <option value="edit-ps" className="color-options">
                        Edit
                    </option>
                )}
                {(isAdmin() && filterConfig.tab !== "completed") && (
                    <option value="delete-ps" className="color-red">
                        Delete
                    </option>
                )}
            </Form.Select>
        );
    }

    function handleFilterChange(e) {
        const { name, value } = e.target;
        setFilterConfig((prev) => {
            return { ...prev, [name]: value };
        });
    }
    useEffect(() => {
        fetchData();
    }, [filterConfig, currentPage]);

    function renderTableMaterialsRequired(type) {
        return (
            <Table>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Required Qty</th>
                        <th>Used Qty</th>
                        <th>Unit</th>
                        {type !== "view" && <th>Action</th>}
                    </tr>
                </thead>
                <tbody>
                    {materialsRequired.map((product, index) => {
                        return (
                            <tr>
                                <td>
                                    {type !== "view" && (
                                        <Form.Select
                                            name="id"
                                            id={product.id}
                                            value={product.id}
                                            onChange={(e) =>
                                                handleMaterialRequiredChange(e, index)
                                            }
                                            disabled={type === "view"}
                                        >
                                            <option value="">Select</option>
                                            {items.map((data) => {
                                                return (
                                                    <option value={data.id}>
                                                        {data.item_name}
                                                    </option>
                                                );
                                            })}
                                        </Form.Select>
                                    )}
                                    {type === "view" && (
                                        <Form.Control
                                            type="text"
                                            name="item_name"
                                            value={product.item_name}
                                            disabled
                                        />
                                    )}
                                </td>
                                <td>
                                    <Form.Control
                                        type="number"
                                        name="qty"
                                        min="0"
                                        className="nc-modal-custom-text hide-spinner numeric-input"
                                        value={product.qty}
                                        onChange={(e) =>
                                            handleMaterialRequiredChange(e, index)
                                        }
                                        disabled={type === "view"}
                                    />
                                </td>
                                <td>
                                    <Form.Control
                                        type="number"
                                        name="qty_used"
                                        min="0"
                                        className="nc-modal-custom-text hide-spinner numeric-input"
                                        value={product.qty_used}
                                        onChange={(e) =>
                                            handleMaterialRequiredChange(e, index)
                                        }
                                        disabled={type === "view"}
                                    />
                                </td>
                                <td>
                                    {type !== "view" && (
                                        <Form.Select
                                            name="unit"
                                            id={product.id}
                                            value={product.unit}
                                            className={
                                                type === "view"
                                                    ? "date-filter"
                                                    : ""
                                            }
                                            onChange={(e) =>
                                                handleMaterialRequiredChange(e, index)
                                            }
                                            disabled={type === "view"}
                                        >
                                            {product?.unitList?.item_units?.map(
                                                (data) => {
                                                    return (
                                                        <option
                                                            key={data.id}
                                                            value={data.id}
                                                        >
                                                            {
                                                                data.unit_to
                                                            }
                                                        </option>
                                                    );
                                                }
                                            )}
                                        </Form.Select>
                                    )}

                                    {type === "view" && (
                                        <Form.Control
                                            type="text"
                                            name="unit"
                                            value={product.unit}
                                            disabled
                                        />
                                    )}
                                </td>
                                {type !== "view" && (
                                    <td>
                                        <div className="align-middle">
                                            <img
                                                src={trash}
                                                alt="delete"
                                                onClick={() =>
                                                    handleRemoveMaterialRequired(index)
                                                }
                                                className="cursor-pointer"
                                            />
                                        </div>
                                    </td>
                                )}
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        );
    }


    function renderTableMaterialsUsed(type) {
        return (
            <Table>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Quantity</th>
                        <th>Unit</th>
                        {type !== "view" && <th>Action</th>}
                    </tr>
                </thead>
                <tbody>
                    {materialsUsed.map((product, index) => {
                        return (
                            <tr>
                                <td>
                                    {type !== "view" && (
                                        <Form.Select
                                            name="id"
                                            id={product.id}
                                            value={product.id}
                                            onChange={(e) =>
                                                handleMaterialUsedChange(e, index)
                                            }
                                            disabled={type === "view"}
                                        >
                                            <option value="">Select</option>
                                            {items.map((data) => {
                                                return (
                                                    <option value={data.id}>
                                                        {data.item_name}
                                                    </option>
                                                );
                                            })}
                                        </Form.Select>
                                    )}
                                    {type === "view" && (
                                        <Form.Control
                                            type="text"
                                            name="item_name"
                                            value={product.item_name}
                                            disabled
                                        />
                                    )}
                                </td>
                                <td>
                                    <Form.Control
                                        type="number"
                                        name="quantity"
                                        min="0"
                                        value={product.quantity}
                                        className="nc-modal-custom-text hide-spinner numeric-input"
                                        onChange={(e) =>
                                            handleMaterialUsedChange(e, index)
                                        }
                                        disabled={type === "view"}
                                    />
                                </td>
                                <td>
                                    {type !== "view" && (
                                        <Form.Select
                                            name="unit"
                                            id={product.id}
                                            value={product.unit}
                                            className={
                                                type === "view"
                                                    ? "date-filter"
                                                    : ""
                                            }
                                            onChange={(e) =>
                                                handleMaterialUsedChange(e, index)
                                            }
                                            disabled={type === "view"}
                                        >
                                            {product?.unitList?.item_units?.map(
                                                (data) => {
                                                    return (
                                                        <option
                                                            key={data.id}
                                                            selected={
                                                                data.unit_to ===
                                                                product.unit
                                                            }
                                                            value={data.id}
                                                        >
                                                            {
                                                                data.unit_to
                                                            }
                                                        </option>
                                                    );
                                                }
                                            )}
                                        </Form.Select>
                                    )}

                                    {type === "view" && (
                                        <Form.Control
                                            type="text"
                                            name="unit"
                                            value={product.unit}
                                            disabled
                                        />
                                    )}
                                </td>
                                {type !== "view" && (
                                    <td>
                                        <div className="align-middle">
                                            <img
                                                src={trash}
                                                alt="delete"
                                                onClick={() =>
                                                    handleRemoveMaterialUsed(index)
                                                }
                                                className="cursor-pointer"
                                            />
                                        </div>
                                    </td>
                                )}
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        );
    }

    //DISABLE SCROLL FUNCTION
    function limitScroll() {
        var numericInputs = document.querySelectorAll('.numeric-input');
        numericInputs.forEach(function(input) {
          input.addEventListener('wheel', function(e) {
            e.preventDefault();
          });
        });
      }
      limitScroll();

    const [itemValue, setItemValue] = useState({
        name: "item_id",
        label: "",
        value: "",
    });
    async function fetchItems() {
        setItems([]);
        const response = await getAllItems(1);
        if(response.response){
            let result = response.response.data.map((a) => {
                return {
                    label: a.name,
                    value: a.id,
                    id: a.id,
                    name: "item_id",
                    item_name: a.name,
                    detail: a.detail,
                    type: a.type,
                    current_qty: a.item_units[0]?.current_qty ?? 0,
                    item_units: a.item_units,
                };
            });
            setItems([{name: "item_id", label: "All Items", value:""}, ...result]);
        }
    }

    const handleSelectDropsearch = (e) => {
        
        if (e.name === "item_id") {
            setItemValue(e);
            setFilterConfig((prev) => {
                return {
                    ...prev,
                    "build_item_id": e.value,
                };
            });
        } else {
            setFilterConfig((prev) => {
                return {
                    ...prev,
                    [e.name]: e.value,
                };
            });
        }
        
    };

    function materialsList(row) {
        var split = row.raw_materials.split(",").slice(0, -1)
        
         return (
            <Row>{
                split.map((data) => {
                    return (
                        <>
                            <label>{data}</label><br/>
                        </>
                    );
                })}
            </Row>
        )
    }

    function ViewBtn(row) {
        return (
            <button
                name="action"
                className="btn btn-sm view-btn-table"
                id={row.id}
                onClick={() => navigate("/builditem/view/" + row.id)}
            >
                View
            </button>
        );
    }


    function CompleteBtn(row) {
        return (
            <button
                name="action"
                className="btn btn-sm view-btn-table"
                id={row.id}
                onClick={() => navigate("/builditem/edit/" + row.id)}
            >
                Complete
            </button>
        );
    }

    const handleTabSelect = (tabKey) => {
        setCurrentPage(1)
        setFilterConfig((prev) => {
            return {
                ...prev,
                tab: tabKey,
                status: tabKey,
                page: 1
            };
        });
    };


    useEffect(() => {
        fetchItems();
        fetchEmployees();
        fetchBranches();
    }, []);

    // useEffect(() => {
    //     fetchBuildItem();
    // }, [selectedRow]);

    // calculate yield
    // useEffect(() => {
    //     var buildQty = qty ? parseFloat(qty) : 0;
    //     materialsRequired.map((product) => {
    //         if (product.id === "115") {
    //             var productQty = product.quantity
    //                 ? parseFloat(product.quantity)
    //                 : 0;
    //             var _yield =
    //                 buildQty && productQty
    //                     ? (buildQty * 800) / 1000 / productQty
    //                     : 0;
    //             setBuild((prevState) => ({
    //                 ...prevState,
    //                 yield: _yield.toFixed(2),
    //             }));
    //         }
    //     });
    // }, [materialsRequired, qty]);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"WH INVENTORY"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> BUILD ITEM </h1>
                    </Col>
                    <Col xs={12} lg={3}>
                    </Col>
                    <Col lg={2} className="mt-3 mt-lg-0">
                        <div className="PO-filters">
                            <button
                                className="add-btn"
                                type="button"
                                onClick={() => navigate("/builditem/add")}
                            >
                                Add
                            </button>
                        </div>
                    </Col>
                </Row>

                <Tabs
                    activeKey={filterConfig.tab}
                    defaultActiveKey={filterConfig.tab}
                    id="PO-tabs"
                    onSelect={handleTabSelect}
                    >
                    <Tab eventKey="pending" title="for approval">
                        <div className="tab-content build-item-register">
                            <div className="mb-3" />
                            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                                Filter By:
                            </span>
                            <Row className="PO-filters flex flex-row mx-2 my-1">
                                <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                                    <Select
                                        className="dropsearch-filter"
                                        classNamePrefix="react-select"
                                        placeholder="Select Item..."
                                        styles={selectDropdownStyle}
                                        // value={itemValue}
                                        options={items}
                                        onChange={handleSelectDropsearch}
                                    />
                                </Col>
                            </Row>
                            <div className="my-2 px-2 PO-filters d-flex justify-content-center">
                                <span className="me-4 ml-4 align-middle ps-label">
                                    Total built item:{" "} {totalBuiltItem.toLocaleString()}
                                </span>
                            </div>
                            <div className="below">
                                {/* table */}
                                <TableWithDynamicPagination
                                    tableHeaders={[
                                        "-",
                                        "JOB ORDER DATE",
                                        "BRANCH FROM",
                                        "BRANCH TO",
                                        "TYPE",
                                        "BUILT ITEM",
                                        "DESCRIPTION",
                                        "ESTIMATED TIME",
                                        "ACKNOWLEDGE BY",
                                        "ACTIONS",
                                    ]}
                                    headerSelector={[
                                        "-",
                                        "order_date",
                                        "branch_from_name",
                                        "branch_to_name",
                                        "type",
                                        "build_item_name",
                                        "description",
                                        "estimated_time",
                                        "acknowledge_by_name",
                                    ]}
                                    tableData={buildItemManager}
                                    ActionBtn={(row) => ActionBtn(row)}
                                    ViewBtn={(row) => ViewBtn(row)}
                                    showLoader={showLoader}
                                    materialsList={(row) => materialsList(row)}
                                    tableType="builditem"
                                    // used in dynamic pagination
                                    totalItems={totalItems}
                                    currentPage={currentPage}
                                    itemsPerPage={itemsPerPage}
                                    handlePageChange={handlePageChange}
                                />
                            </div>
                            <div className="mb-2" />
                        </div>
                    </Tab>
                    <Tab eventKey="approved" title="approved">
                        <div className="tab-content build-item-register">
                        <div className="mb-3" />
                            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                                Filter By:
                            </span>
                            <Row className="PO-filters flex flex-row mx-2 my-1">
                                <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                                    <Select
                                        className="dropsearch-filter"
                                        classNamePrefix="react-select"
                                        placeholder="Select Item..."
                                        styles={selectDropdownStyle}
                                        // value={itemValue}
                                        options={items}
                                        onChange={handleSelectDropsearch}
                                    />
                                </Col>
                            </Row>
                            <div className="my-2 px-2 PO-filters d-flex justify-content-center">
                                <span className="me-4 ml-4 align-middle ps-label">
                                    Total built item:{" "} {totalBuiltItem.toLocaleString()}
                                </span>
                            </div>
                            <div className="below">
                                {/* table */}
                                <TableWithDynamicPagination
                                    tableHeaders={[
                                        "-",
                                        "JOB ORDER DATE",
                                        "BRANCH FROM",
                                        "BRANCH TO",
                                        "TYPE",
                                        "BUILT ITEM",
                                        "DESCRIPTION",
                                        "ESTIMATED TIME",
                                        "ACKNOWLEDGE BY",
                                        "ACTIONS",
                                    ]}
                                    headerSelector={[
                                        "-",
                                        "order_date",
                                        "branch_from_name",
                                        "branch_to_name",
                                        "type",
                                        "build_item_name",
                                        "description",
                                        "estimated_time",
                                        "acknowledge_by_name",
                                    ]}
                                    tableData={buildItemManager}
                                    ActionBtn={(row) => ActionBtn(row)}
                                    ViewBtn={(row) => CompleteBtn(row)}
                                    showLoader={showLoader}
                                    materialsList={(row) => materialsList(row)}
                                    tableType="builditem"
                                    // used in dynamic pagination
                                    totalItems={totalItems}
                                    currentPage={currentPage}
                                    itemsPerPage={itemsPerPage}
                                    handlePageChange={handlePageChange}
                                />
                            </div>
                            <div className="mb-2" />
                        </div>
                    </Tab>
                    <Tab eventKey="completed" title="completed">
                        <div className="tab-content build-item-register">
                        <div className="mb-3" />
                            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                                Filter By:
                            </span>
                            <Row className="PO-filters flex flex-row mx-2 my-1">
                                <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                                    <Select
                                        className="dropsearch-filter"
                                        classNamePrefix="react-select"
                                        placeholder="Select Item..."
                                        styles={selectDropdownStyle}
                                        // value={itemValue}
                                        options={items}
                                        onChange={handleSelectDropsearch}
                                    />
                                </Col>
                            </Row>
                            <div className="my-2 px-2 PO-filters d-flex justify-content-center">
                                <span className="me-4 ml-4 align-middle ps-label">
                                    Total built item:{" "} {totalBuiltItem.toLocaleString()}
                                </span>
                            </div>
                            <div className="below">
                                {/* table */}
                                <TableWithDynamicPagination
                                    tableHeaders={[
                                        "-",
                                        "JOB ORDER DATE",
                                        "BRANCH FROM",
                                        "BRANCH TO",
                                        "TYPE",
                                        "BUILT ITEM",
                                        "DESCRIPTION",
                                        "ESTIMATED TIME",
                                        "ACKNOWLEDGE BY",
                                        "COMPLETED ON",
                                        "COMPLETED BY",
                                        "ACTIONS",
                                    ]}
                                    headerSelector={[
                                        "-",
                                        "order_date",
                                        "branch_from_name",
                                        "branch_to_name",
                                        "type",
                                        "build_item_name",
                                        "description",
                                        "estimated_time",
                                        "acknowledge_by_name",
                                        "completed_on",
                                        "completed_by_name",
                                    ]}
                                    tableData={buildItemManager}
                                    ActionBtn={(row) => ActionBtn(row)}
                                    ViewBtn={(row) => ViewBtn(row)}
                                    showLoader={showLoader}
                                    materialsList={(row) => materialsList(row)}
                                    tableType="builditem"
                                    // used in dynamic pagination
                                    totalItems={totalItems}
                                    currentPage={currentPage}
                                    itemsPerPage={itemsPerPage}
                                    handlePageChange={handlePageChange}
                                />
                            </div>
                            <div className="mb-2" />
                        </div>
                    </Tab>
                    <Tab eventKey="rejected" title="rejected">
                        <div className="tab-content build-item-register">
                        <div className="mb-3" />
                            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                                Filter By:
                            </span>
                            <Row className="PO-filters flex flex-row mx-2 my-1">
                                <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                                    <Select
                                        className="dropsearch-filter"
                                        classNamePrefix="react-select"
                                        placeholder="Select Item..."
                                        styles={selectDropdownStyle}
                                        // value={itemValue}
                                        options={items}
                                        onChange={handleSelectDropsearch}
                                    />
                                </Col>
                            </Row>
                            <div className="my-2 px-2 PO-filters d-flex justify-content-center">
                                <span className="me-4 ml-4 align-middle ps-label">
                                    Total built item:{" "} {totalBuiltItem.toLocaleString()}
                                </span>
                            </div>
                            <div className="below">
                                {/* table */}
                                <TableWithDynamicPagination
                                    tableHeaders={[
                                        "-",
                                        "JOB ORDER DATE",
                                        "BRANCH FROM",
                                        "BRANCH TO",
                                        "TYPE",
                                        "BUILT ITEM",
                                        "DESCRIPTION",
                                        "ESTIMATED TIME",
                                        "ACKNOWLEDGE BY",
                                        "ACTIONS",
                                    ]}
                                    headerSelector={[
                                        "-",
                                        "order_date",
                                        "branch_from_name",
                                        "branch_to_name",
                                        "type",
                                        "build_item_name",
                                        "description",
                                        "estimated_time",
                                        "acknowledge_by_name",
                                    ]}
                                    tableData={buildItemManager}
                                    ActionBtn={(row) => ActionBtn(row)}
                                    ViewBtn={(row) => ViewBtn(row)}
                                    showLoader={showLoader}
                                    materialsList={(row) => materialsList(row)}
                                    tableType="builditem"
                                    // used in dynamic pagination
                                    totalItems={totalItems}
                                    currentPage={currentPage}
                                    itemsPerPage={itemsPerPage}
                                    handlePageChange={handlePageChange}
                                />
                            </div>
                            <div className="mb-2" />
                        </div>
                    </Tab>
                    <Tab eventKey="" title="all">
                        <div className="tab-content build-item-register">
                        <div className="mb-3" />
                            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                                Filter By:
                            </span>
                            <Row className="PO-filters flex flex-row mx-2 my-1">
                                <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                                    <Select
                                        className="dropsearch-filter"
                                        classNamePrefix="react-select"
                                        placeholder="Select Item..."
                                        styles={selectDropdownStyle}
                                        // value={itemValue}
                                        options={items}
                                        onChange={handleSelectDropsearch}
                                    />
                                </Col>
                            </Row>
                            <div className="my-2 px-2 PO-filters d-flex justify-content-center">
                                <span className="me-4 ml-4 align-middle ps-label">
                                    Total built item:{" "} {totalBuiltItem.toLocaleString()}
                                </span>
                            </div>
                            <div className="below">
                                {/* table */}
                                <TableWithDynamicPagination
                                    tableHeaders={[
                                        "-",
                                        "JOB ORDER DATE",
                                        "BRANCH FROM",
                                        "BRANCH TO",
                                        "TYPE",
                                        "BUILT ITEM",
                                        "DESCRIPTION",
                                        "ESTIMATED TIME",
                                        "ACKNOWLEDGE BY",
                                        "COMPLETED ON",
                                        "COMPLETED BY",
                                        "ACTIONS",
                                    ]}
                                    headerSelector={[
                                        "-",
                                        "order_date",
                                        "branch_from_name",
                                        "branch_to_name",
                                        "type",
                                        "build_item_name",
                                        "description",
                                        "estimated_time",
                                        "acknowledge_by_name",
                                        "completed_on",
                                        "completed_by_name",
                                    ]}
                                    tableData={buildItemManager}
                                    ActionBtn={(row) => ActionBtn(row)}
                                    ViewBtn={(row) => ViewBtn(row)}
                                    showLoader={showLoader}
                                    materialsList={(row) => materialsList(row)}
                                    tableType="builditem"
                                    // used in dynamic pagination
                                    totalItems={totalItems}
                                    currentPage={currentPage}
                                    itemsPerPage={itemsPerPage}
                                    handlePageChange={handlePageChange}
                                />
                            </div>
                            <div className="mb-2" />
                        </div>
                    </Tab>
                </Tabs>
                
            </div>

            {/* modals */}
            <Delete
                show={showDeleteModal}
                onHide={handleCloseDeleteModal}
                text="build item"
                onDelete={handleDeleteBuildItem}
                isClicked={isClicked}
            />
            <Modal
                show={showAddBranchModal}
                onHide={handleCloseAddBranchModal}
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <p className="custom-modal-body-title"> Build Item </p>
                </Modal.Header>
                <Modal.Body>
                    <div className="text">
                        Branch
                        <Form.Select
                            name="branch"
                            className="date-filter me-3"
                            onChange={(e) => handleBuildInfoChange(e)}
                        >
                            <option value="" hidden>
                                Select
                            </option>
                            {branches
                                .filter(
                                    (info) =>
                                        info.name === "Warehouse"
                                )
                                .map((data) => {
                                    return (
                                        <option
                                            value={data.id}
                                        >
                                            {data.name}
                                        </option>
                                    );
                                })}
                        </Form.Select>
                    </div>
                    <div className="text mt-3">
                        Item to Build
                        <Select
                            className="react-select-container"
                            classNamePrefix="react-select"
                            placeholder="Select item..."
                            options={items}
                            onChange={(e) => handleBuildInfoChange(e.value)}
                        />
                        <p className="add-supplier-prompt mb-0">
                            ITEM NOT FOUND?{" "}
                            <a
                                className="add-supplier-label"
                                onClick={() => navigate("/items")}
                            >
                                Click to add item
                            </a>
                        </p>
                    </div>
                    <div className="col-sm-12 mt-3 d-flex justify-content-end">
                        <button
                            className="button-primary  me-3"
                            onClick={() => {
                                handleShowAddItemModal();
                                handleCloseAddBranchModal();
                            }}
                        >
                            Proceed
                        </button>
                    </div>
                </Modal.Body>
            </Modal>


            <AddModal
                title={`BUILD ITEM`}
                type="product"
                show={showAddItemModal}
                onHide={handleCloseAddItemModal}
                onSave={() => handleSaveBuildItem()}
                isClicked={isClicked}
            >
                <div className="mt-3 ">
                    <Row className="nc-modal-custom-row ">
                        <Col sm={4}>Branch</Col>
                        <Col sm={4}>
                            <Form.Select
                                name="branch_from"
                                className="date-filter me-3"
                                value={build.branch_from}
                                onChange={(e) => handleBuildInfoChange(e)}
                            >
                                <option value="" hidden>
                                    Select
                                </option>
                                {branches.map((data) => {
                                    return (
                                        <option
                                            value={data.id}
                                        >
                                            {data.name}
                                        </option>
                                    );
                                })}
                            </Form.Select>
                            <InputError
                                isValid={isError.branch_from}
                                message={"Ingredients from value is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Requested By</Col>
                        <Col sm={4}>
                            <Form.Select
                                name="requested_by"
                                className="date-filter me-3"
                                onChange={(e) => handleBuildInfoChange(e)}
                                value={build.requested_by}
                            >
                                <option value="" hidden>
                                    Select
                                </option>
                                {employees.map((data) => {
                                    return (
                                        <option
                                            value={data.id}
                                        >
                                            {data.name}
                                        </option>
                                    );
                                })}
                            </Form.Select>
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Date Issued</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="date"
                                name="job_order_date"
                                value={build.job_order_date}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleBuildInfoChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.job_order_date}
                                message={"Date is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col>ORDER DETAILS</Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Type</Col>
                        <Col sm={4}>
                            <Form.Select
                                name="type"
                                className="date-filter me-3"
                                value={build.type}
                                onChange={(e) => handleBuildInfoChange(e)}
                            >
                                <option value="" hidden> Select</option>
                                <option value="item" > Build Item</option>
                                <option value="job" > Job Order</option>
                            </Form.Select>
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Build Item</Col>
                        <Col sm={4}>
                            <Form.Select
                                name="build_item_id"
                                className="date-filter me-3"
                                value={build.build_item_id}
                                onChange={(e) => handleBuildInfoChange(e)}
                            >
                                <option value="" hidden>
                                    Select
                                </option>
                                {items.map((data) => {
                                        return (
                                            <option
                                                value={data.id}
                                            >
                                                {data.item_name}
                                            </option>
                                        );
                                    })}
                            </Form.Select>
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Build Quantity</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="number"
                                name="build_item_qty"
                                value={build.build_item_qty}
                                className="nc-modal-custom-text hide-spinner numeric-input"
                                onChange={(e) => handleBuildInfoChange(e)}
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Requesting To</Col>
                        <Col sm={4}>
                            <Form.Select
                                name="requesting_to"
                                className="date-filter me-3"
                                value={build.requesting_to}
                                onChange={(e) => handleBuildInfoChange(e)}
                            >
                                <option value="" hidden>
                                    Select
                                </option>
                                {branches
                                    // .filter(
                                    //     (info) =>
                                    //         info.name === "Warehouse"
                                    // )
                                    .map((data) => {
                                        return (
                                            <option
                                                value={data.id}
                                            >
                                                {data.name}
                                            </option>
                                        );
                                    })}
                            </Form.Select>
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Description of Work</Col>
                        <Col sm={4}>
                            <textarea
                                type="text"
                                name="description"
                                value={build.description}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleBuildInfoChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.description}
                                message={"Description is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Estimated Time</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="text"
                                name="estimated_time"
                                value={build.estimated_time}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleBuildInfoChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.estimated_time}
                                message={"Description is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col>Materials</Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <div className="edit-purchased-items">
                            {materialsRequired.length === 0 ? (
                                <span>No Materials Found!</span>
                            ) : (
                                renderTableMaterialsRequired()
                            )}
                            <InputError
                                isValid={isError.ingredients}
                                message={"At least 1 ingredient is required"}
                            />
                        </div>
                    </Row>
                    <Row className="pt-3 PO-add-item">
                        <Button type="button" onClick={() => AddMaterialRequiredBtn()}>
                            Add Ingredient
                        </Button>
                    </Row>
                    {/* <Row className="nc-modal-custom-row">
                        <Col>Materials Used</Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <div className="edit-purchased-items">
                            {materialsUsed.length === 0 ? (
                                <span>No Materials Found!</span>
                            ) : (
                                renderTableMaterialsUsed()
                            )}
                            <InputError
                                isValid={isError.ingredients}
                                message={"At least 1 ingredient is required"}
                            />
                        </div>
                    </Row>
                    <Row className="pt-3 PO-add-item">
                        <Button type="button" onClick={() => AddMaterialUsedBtn()}>
                            Add Ingredient
                        </Button>
                    </Row> */}
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Date Completed</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="date"
                                name="date_completed"
                                value={build.date_completed}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleBuildInfoChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.date_completed}
                                message={"Date is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Time In</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="datetime-local"
                                name="time_in"
                                defaultValue={build.time_in}
                                className="react-select-container"
                                onChange={(e) => handleBuildInfoChange(e)}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Time out</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="datetime-local"
                                name="time_end"
                                defaultValue={build.time_end}
                                className="react-select-container"
                                onChange={(e) => handleBuildInfoChange(e)}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Acknowledged By</Col>
                        <Col sm={4}>
                            <Form.Select
                                name="acknowledge_by"
                                className="date-filter me-3"
                                onChange={(e) => handleBuildInfoChange(e)}
                                value={build.acknowledge_by}
                            >
                                <option value="" hidden>
                                    Select
                                </option>
                                {employees.map((data) => {
                                        return (
                                            <option
                                                value={data.id}
                                            >
                                                {data.name}
                                            </option>
                                        );
                                    })}
                            </Form.Select>
                        </Col>
                    </Row>
                    {
                        accountType === "admin" && (
                            <>
                                <Row className="nc-modal-custom-row">
                                    <Col>Complete Information (For Admin Only)</Col>
                                </Row>
                                <Row className="nc-modal-custom-row">
                                    <Col sm={3}>Job Order No.</Col>
                                    <Col sm={3}>
                                        <Form.Control
                                            type="text"
                                            name="job_order_no"
                                            value={build.job_order_no}
                                            className="nc-modal-custom-input"
                                            onChange={(e) => handleBuildInfoChange(e)}
                                            required
                                        />
                                        <InputError
                                            isValid={isError.job_order_no}
                                            message={"Job Order No. is required"}
                                        />
                                    </Col>
                                    <Col sm={3}>Schedule Date</Col>
                                    <Col sm={3}>
                                        <Form.Control
                                            type="datetime-local"
                                            name="schedule_date"
                                            value={build.schedule_date}
                                            className="nc-modal-custom-input"
                                            onChange={(e) => handleBuildInfoChange(e)}
                                            required
                                        />
                                        <InputError
                                            isValid={isError.schedule_date}
                                            message={"Job order no. is required"}
                                        />
                                    </Col>
                                </Row>
                                <Row className="nc-modal-custom-row">
                                    <Col sm={3}>Job Requesting To</Col>
                                    <Col sm={3}>
                                        <Form.Control
                                            type="text"
                                            name="job_requesting_to"
                                            value={build.job_requesting_to}
                                            className="nc-modal-custom-input"
                                            onChange={(e) => handleBuildInfoChange(e)}
                                            required
                                        />
                                        <InputError
                                            isValid={isError.job_requesting_to}
                                            message={"Job requesting to is required"}
                                        />
                                    </Col>
                                </Row>
                                <Row className="nc-modal-custom-row">
                                    <Col sm={3}>Remarks</Col>
                                    <Col >
                                        <textarea
                                            type="text"
                                            name="remarks"
                                            value={build.remarks}
                                            className="nc-modal-custom-input"
                                            onChange={(e) => handleBuildInfoChange(e)}
                                            required
                                        />
                                        <InputError
                                            isValid={isError.remarks}
                                            message={"Remarks is required"}
                                        />
                                    </Col>
                                </Row>
                            </>
                        )
                    }
                    <Row className="mt-4 pt-3">
                        <Col>
                            <span className="edit-label">File Attachment</span>
                            <Dragger
                                {...{
                                file,
                                defaultFileList: file,
                                onRemove: handleRemove,
                                beforeUpload: handleBeforeUpload,
                                multiple: false,
                                listType: "picture",
                                progress: { showInfo: true },
                                data: (file) => {},
                                }}
                            >
                                <img alt="upload" src={upload} className="cursor-pointer" />
                                <p className="ant-upload-text">
                                Click or drag file to this area to upload
                                </p>
                            </Dragger>
                        </Col>
                    </Row>
                </div>
            </AddModal>

            {/* <AddModal
                title={`BUILD ITEM`}
                type="product"
                show={showAddItemModal}
                onHide={handleCloseAddItemModal}
                onSave={() => handleSaveBuildItem()}
                isClicked={isClicked}
            >
                <div className="mt-3 ">
                    <Row className="nc-modal-custom-row mt-0">
                        <Col sm={4}>Branch</Col>
                        <Col>
                            <div className="plain-text">
                                {branchTo.split("|")[1]}
                            </div>
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row mt-0">
                        <Col sm={4}>Item description</Col>
                        <Col>
                            <div className="plain-text">
                                {itemInfo[0]?.label}
                            </div>
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row mt-0">
                        <Col sm={4}>Current Level</Col>
                        <Col>
                            <div className="plain-text">
                                {itemInfo[0]?.current_qty}
                            </div>
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row mt-0">
                        <Col sm={4}>Qty</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="number"
                                name="qty"
                                value={qty}
                                className="nc-modal-custom-input"
                                onChange={(e) => setQty(e.target.value)}
                                required
                            />
                            <InputError
                                isValid={isError.qty}
                                message={"Quantity is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Harvest Date</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="date"
                                name="processing_date"
                                value={build.processing_date}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleBuildInfoChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.processing_date}
                                message={"Harvest date is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Production Date</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="date"
                                name="production_date"
                                value={build.production_date}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleBuildInfoChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.production_date}
                                message={"Production date is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Expiration Date</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="date"
                                name="expiration_date"
                                value={build.expiration_date}
                                min={build.production_date}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleBuildInfoChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.expiration_date}
                                message={"Expiration date is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Ripening Date</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="text"
                                name="ripening_day"
                                value={build.ripening_day}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleBuildInfoChange(e)}
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Batch</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="text"
                                name="batch"
                                value={build.batch}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleBuildInfoChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.batch}
                                message={"Batch is required"}
                            />
                        </Col>
                    </Row>

                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Yield</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="text"
                                name="yield"
                                value={build.yield}
                                className="nc-modal-custom-input"
                                disabled
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Production Slip No.</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="text"
                                name="production_slip_no"
                                value={build.production_slip_no}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleBuildInfoChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.production_slip_no}
                                message={"Production slip number is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row ">
                        <Col sm={4}>Ingredients From</Col>
                        <Col sm={4}>
                            <Form.Select
                                name="branch_from"
                                className="date-filter me-3"
                                value={branchFrom}
                                onChange={(e) => setBranchFrom(e.target.value)}
                            >
                                {branches.map((data) => {
                                    return (
                                        <option
                                            value={data.id}
                                        >
                                            {data.name}
                                        </option>
                                    );
                                })}
                            </Form.Select>
                            <InputError
                                isValid={isError.branch_from}
                                message={"Ingredients from value is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Brix</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="text"
                                name="brix"
                                value={build.brix}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleBuildInfoChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.brix}
                                message={"Production slip number is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Remarks</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="text"
                                name="remarks"
                                value={build.remarks}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleBuildInfoChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.remarks}
                                message={"Production slip number is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col>INGREDIENTS</Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <div className="edit-purchased-items">
                            {materialsRequired.length === 0 ? (
                                <span>No Ingredients for Products Found!</span>
                            ) : (
                                renderTable()
                            )}
                            <InputError
                                isValid={isError.ingredients}
                                message={"At least 1 ingredient is required"}
                            />
                        </div>
                    </Row>
                    <Row className="pt-3 PO-add-item">
                        <Button type="button" onClick={() => AddMaterialRequiredBtn()}>
                            Add Ingredient
                        </Button>
                    </Row>
                </div>
            </AddModal> */}
            <EditModal
                title={`BUILD ITEM`}
                type="product"
                show={showEditItemModal}
                onHide={handleCloseEditItemModal}
                onSave={() => handleUpdateBuildItem()}
                isClicked={isClicked}
            >
                <div className="mt-3 ">
                    <Row className="nc-modal-custom-row ">
                        <Col sm={4}>Branch</Col>
                        <Col sm={4}>
                            <Form.Select
                                name="branch_from"
                                className="date-filter me-3"
                                value={build.branch_from}
                                onChange={(e) => handleBuildInfoChange(e)}
                            >
                                <option value="" hidden>
                                    Select
                                </option>
                                {branches.map((data) => {
                                    return (
                                        <option
                                            value={data.id}
                                        >
                                            {data.name}
                                        </option>
                                    );
                                })}
                            </Form.Select>
                            <InputError
                                isValid={isError.branch_from}
                                message={"Ingredients from value is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row ">
                        <Col sm={4}>Requested By</Col>
                        <Col sm={4}>
                            <Form.Select
                                name="requested_by"
                                className="date-filter me-3"
                                onChange={(e) => handleBuildInfoChange(e)}
                                value={build.requested_by}
                            >
                                <option value="" hidden>
                                    Select
                                </option>
                                {employees.map((data) => {
                                    return (
                                        <option
                                            value={data.id}
                                        >
                                            {data.name}
                                        </option>
                                    );
                                })}
                            </Form.Select>
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Date Issued</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="date"
                                name="job_order_date"
                                value={build.job_order_date}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleBuildInfoChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.job_order_date}
                                message={"Date is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col>ORDER DETAILS</Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Type</Col>
                        <Col sm={4}>
                            <Form.Select
                                name="type"
                                className="date-filter me-3"
                                value={build.type}
                                onChange={(e) => handleBuildInfoChange(e)}
                            >
                                <option value="" hidden> Select</option>
                                <option value="item" > Build Item</option>
                                <option value="job" > Job Order</option>
                            </Form.Select>
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Build Item</Col>
                        <Col sm={4}>
                            <Form.Select
                                name="build_item_id"
                                className="date-filter me-3"
                                value={build.build_item_id}
                                onChange={(e) => handleBuildInfoChange(e)}
                            >
                                <option value="" hidden>
                                    Select
                                </option>
                                {items.map((data) => {
                                        return (
                                            <option
                                                value={data.id}
                                            >
                                                {data.item_name}
                                            </option>
                                        );
                                    })}
                            </Form.Select>
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Build Quantity</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="number"
                                name="build_item_qty"
                                value={build.build_item_qty}
                                className="nc-modal-custom-text hide-spinner numeric-input"
                                onChange={(e) => handleBuildInfoChange(e)}
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Requesting To</Col>
                        <Col sm={4}>
                            <Form.Select
                                name="requesting_to"
                                className="date-filter me-3"
                                onChange={(e) => handleBuildInfoChange(e)}
                                value={build.requesting_to}
                            >
                                <option value="" hidden>
                                    Select
                                </option>
                                {branches
                                    .map((data) => {
                                        return (
                                            <option
                                                value={data.id}
                                            >
                                                {data.name}
                                            </option>
                                        );
                                    })}
                            </Form.Select>
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Description of Work</Col>
                        <Col sm={4}>
                            <textarea
                                type="text"
                                name="description"
                                value={build.description}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleBuildInfoChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.description}
                                message={"Description is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Estimated Time</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="text"
                                name="estimated_time"
                                value={build.estimated_time}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleBuildInfoChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.estimated_time}
                                message={"Description is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col>Materials Required</Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <div className="edit-purchased-items">
                            {materialsRequired.length === 0 ? (
                                <span>No Materials Found!</span>
                            ) : (
                                renderTableMaterialsRequired()
                            )}
                            <InputError
                                isValid={isError.ingredients}
                                message={"At least 1 ingredient is required"}
                            />
                        </div>
                    </Row>
                    <Row className="pt-3 PO-add-item">
                        <Button type="button" onClick={() => AddMaterialRequiredBtn()}>
                            Add Ingredient
                        </Button>
                    </Row>
                    {/* <Row className="nc-modal-custom-row">
                        <Col>Materials Used</Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <div className="edit-purchased-items">
                            {materialsUsed.length === 0 ? (
                                <span>No Materials Found!</span>
                            ) : (
                                renderTableMaterialsUsed()
                            )}
                            <InputError
                                isValid={isError.ingredients}
                                message={"At least 1 ingredient is required"}
                            />
                        </div>
                    </Row>
                    <Row className="pt-3 PO-add-item">
                        <Button type="button" onClick={() => AddMaterialUsedBtn()}>
                            Add Ingredient
                        </Button>
                    </Row> */}
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Date Completed</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="date"
                                name="date_completed"
                                value={build.date_completed}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleBuildInfoChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.date_completed}
                                message={"Date is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Time In</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="datetime-local"
                                name="time_in"
                                defaultValue={build.time_in}
                                className="react-select-container"
                                onChange={(e) => handleBuildInfoChange(e)}
                            />
                            {/* <InputError
                                isValid={isError.date_completed}
                                message={"Date is required"}
                            /> */}
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Time out</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="datetime-local"
                                name="time_end"
                                defaultValue={build.time_end}
                                className="react-select-container"
                                onChange={(e) => handleBuildInfoChange(e)}
                            />
                            {/* <InputError
                                isValid={isError.date_completed}
                                message={"Date is required"}
                            /> */}
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Acknowledged By</Col>
                        <Col sm={4}>
                            <Form.Select
                                name="acknowledge_by"
                                className="date-filter me-3"
                                onChange={(e) => handleBuildInfoChange(e)}
                                value={build.acknowledge_by}
                            >
                                <option value="" hidden>
                                    Select
                                </option>
                                {employees.map((data) => {
                                        return (
                                            <option
                                                value={data.id}
                                            >
                                                {data.name}
                                            </option>
                                        );
                                    })}
                            </Form.Select>
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col>Complete Information (For Admin Only)</Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={3}>Job Order No.</Col>
                        <Col sm={3}>
                            <Form.Control
                                type="text"
                                name="job_order_no"
                                value={build.job_order_no}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleBuildInfoChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.job_order_no}
                                message={"Job Order No. is required"}
                            />
                        </Col>
                        <Col sm={3}>Schedule Date</Col>
                        <Col sm={3}>
                            <Form.Control
                                type="datetime-local"
                                name="schedule_date"
                                value={build.schedule_date}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleBuildInfoChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.schedule_date}
                                message={"Job order no. is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={3}>Job Requesting To</Col>
                        <Col sm={3}>
                            <Form.Control
                                type="text"
                                name="job_requesting_to"
                                value={build.job_requesting_to}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleBuildInfoChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.job_requesting_to}
                                message={"Job requesting to is required"}
                            />
                        </Col>
                        {/* <Col sm={3}>Schedule Time</Col>
                        <Col sm={3}>
                            <Form.Control
                                type="time"
                                name="schedule_time"
                                defaultValue={build.schedule_time}
                                className="react-select-container"
                                onChange={(e) => handleBuildInfoChange(e)}
                            />
                            <InputError
                                isValid={isError.schedule_time}
                                message={"Time is required"}
                            />
                        </Col> */}
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={3}>Remarks</Col>
                        <Col >
                            <textarea
                                type="text"
                                name="remarks"
                                value={build.remarks}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleBuildInfoChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.remarks}
                                message={"Remarks is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="mt-4 pt-3">
                        <Col>
                            <span className="edit-label">File Attachment</span>
                            <Dragger
                                {...{
                                file,
                                defaultFileList: file,
                                onRemove: handleRemove,
                                beforeUpload: handleBeforeUpload,
                                multiple: false,
                                listType: "picture",
                                progress: { showInfo: true },
                                data: (file) => {},
                                }}
                            >
                                <img alt="upload" src={upload} className="cursor-pointer" />
                                <p className="ant-upload-text">
                                Click or drag file to this area to upload
                                </p>
                            </Dragger>
                        </Col>
                    </Row>
                </div>
            </EditModal>
            <ViewModal
                title={`BUILD ITEM`}
                type="product"
                show={showViewItemModal}
                onHide={handleCloseViewItemModal}
            >
                <div className="mt-3 edit-form">
                    <Row className="nc-modal-custom-row mt-0">
                        <Col sm={4}>Branch</Col>
                        <Col>
                            <div className="plain-text">
                                {branchInfo[0]?.name}
                            </div>
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row mt-0">
                        <Col sm={4}>Item description</Col>
                        <Col>
                            <div className="plain-text">
                                {itemInfo[0]?.item_name}
                            </div>
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row mt-0">
                        <Col sm={4}>Current Level</Col>
                        <Col>
                            <div className="plain-text">{build?.total_qty}</div>
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row mt-0">
                        <Col sm={4}>Qty</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="number"
                                name="qty"
                                value={qty}
                                className="nc-modal-custom-input"
                                onChange={(e) => setQty(e.target.value)}
                                disabled
                            />
                            <InputError
                                isValid={isError.qty}
                                message={"Quantity is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Production Date</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="date"
                                name="production_date"
                                value={build.production_date}
                                className="nc-modal-custom-input"
                                disabled
                            />
                            <InputError
                                isValid={isError.production_date}
                                message={"Production date is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Expiration Date</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="date"
                                name="expiration_date"
                                value={build.expiration_date}
                                className="nc-modal-custom-input"
                                disabled
                            />
                            <InputError
                                isValid={isError.expiration_date}
                                message={"Expiration date is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Ripening Date</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="date"
                                name="ripening_date"
                                value={build.ripening_date}
                                className="nc-modal-custom-input"
                                disabled
                            />
                            <InputError
                                isValid={isError.ripening_date}
                                message={"ripening date is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Batch</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="text"
                                name="batch"
                                value={build.batch}
                                className="nc-modal-custom-input"
                                disabled
                            />
                            <InputError
                                isValid={isError.batch}
                                message={"Batch is required"}
                            />
                        </Col>
                    </Row>
                    {itemInfo[0]?.id === "112" && (
                        <Row className="nc-modal-custom-row">
                            <Col sm={4}>Yield</Col>
                            <Col sm={4}>
                                <Form.Control
                                    type="text"
                                    name="yield"
                                    value={build.yield}
                                    className="nc-modal-custom-input"
                                    disabled
                                />
                                <InputError
                                    isValid={isError.batch}
                                    message={"Yield is required"}
                                />
                            </Col>
                        </Row>
                    )}
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Production Slip No.</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="text"
                                name="production_slip_no"
                                value={build.production_slip_no}
                                className="nc-modal-custom-input"
                                disabled
                            />
                            <InputError
                                isValid={isError.production_slip_no}
                                message={"Production slip number is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row mt-2">
                        <Col sm={4}>Ingredients From</Col>
                        <Col sm={4}>
                            <select
                                name="branch_from"
                                className="date-filter me-3"
                                value={branchFrom}
                                onChange={(e) => setBranchFrom(e.target.value)}
                                readonly
                                disabled
                            >
                                {branches.map((data) => {
                                    return (
                                        <option value={data.id}>
                                            {data.name}
                                        </option>
                                    );
                                })}
                            </select>
                            <InputError
                                isValid={isError.branch_from}
                                message={"Ingredients from value is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Brix</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="text"
                                name="brix"
                                value={build.brix}
                                className="nc-modal-custom-input"
                                disabled
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Remarks</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="text"
                                name="remarks"
                                value={build.remarks}
                                className="nc-modal-custom-input"
                                disabled
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col>INGREDIENTS</Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <div className="edit-purchased-items">
                            {materialsRequired.length === 0 ? (
                                <span>No Ingredients for Products Found!</span>
                            ) : (
                                renderTableMaterialsRequired("view")
                            )}
                            <InputError
                                isValid={isError.ingredients}
                                message={"At least 1 ingredient is required"}
                            />
                        </div>
                    </Row>
                    <Row className="pt-3 PO-add-item">
                    </Row>
                </div>
            </ViewModal>
            <Footer/>
        </div>
    );
}